<template>
    <div class="man-preventiva-lancamento">
        <PageTitle icon="fa fa-cogs" main="Preventiva"
            sub="Cadastros \ Lançamentos \ Relatórios" />
        <div class="man-preventiva-lancamento-tabs">
            <b-card no-body>
                <b-tabs>       
                    <b-tab title="Monitoramento" active><ManPreventivaOsErp /></b-tab>                                 
                    <b-tab title="Painel"><ManPreventivaPainel /></b-tab>                                 
                    <b-tab title="Ordens de serviço com observações" ><ManPreventivaObservacao /></b-tab>                                                            
                    <b-tab title="KM atual serviços"><ManPreventivaOsHistorico /></b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import ManPreventivaOsErp from '../man_preventiva/ManPreventivaOsErp'
import ManPreventivaPainel from '../man_preventiva/ManPreventivaPainel'
import ManPreventivaObservacao from '../man_preventiva/ManPreventivaObservacao'
import ManPreventivaOsHistorico from '../man_preventiva/ManPreventivaOsHistorico'
export default {
    name: 'ManPreventivaLancamento',    
    components: { PageTitle, ManPreventivaOsErp,ManPreventivaPainel,ManPreventivaObservacao,ManPreventivaOsHistorico }
}
</script>

<style>

</style>
